<cc-date-picker
  class="item-expiry-date"
  [class.empty]="!property.value"
  [class.expired]="expirationModes.compare(getPropertyValue(), expirationModes.modes.expired, timezone)"
  [class.expiring]="expirationModes.compare(getPropertyValue(), expirationModes.modes.expiring, timezone)"
  [class.valid]="expirationModes.compare(getPropertyValue(), expirationModes.modes.valid, timezone)"
  [ngModel]="property._dateValue"
  (ngModelChange)="onPropertyUpdated($event)"
  [name]="property.id + 'date-expiry-input'"
  [disabled]="!editable"
  [container]="'body'"
>
</cc-date-picker>
